var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sage-avatar",class:_vm.stateClass,style:(_vm.sizeStyle),attrs:{"aria-label":_vm.ariaLabel,"role":"img"}},[_c('span',{staticClass:"sage-avatar-letter"},[_vm._v("S")]),(_vm.state === 'thinking')?_c('span',{staticClass:"sage-avatar-ring"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }